import React, { useState, useEffect } from "react";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import { UilBars } from "@iconscout/react-unicons";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import title from "../../images/logo192.png";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import icon from "../../images/logo192.png";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import logo from "../../images/newuser.png";
import PaymentRoundedIcon from "@mui/icons-material/PaymentRounded";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import ReceiptIcon from "@mui/icons-material/Receipt";
import Event from "@mui/icons-material/Event";
import CreditScoreIcon from "@mui/icons-material/CreditScore";

const Sidebars = ({ userData, sidebar, role }) => {
  const [activeMenu, setActiveMenu] = useState("/vender-payment-creation");
  const location = useLocation();

  useEffect(() => {
    setActiveMenu(location.pathname);
  }, [location.pathname]);
  const sidebarMenuItems = [
    {
      label: "Create New User",
      icon: PersonAddAltRoundedIcon,
      path: "/create-new-user",
      allowedRoles: [1,2,3,4,5],
    },
    {
      label: "Vendor Payment Payable",
      icon: GridViewRoundedIcon,
      path: "/vendor-payment-creation-payable",
      allowedRoles: [6,8,10],
    },
    // {
    //   label: "Vendor Payment Receivable",
    //   icon: GridViewRoundedIcon,
    //   path: "/vendor-payment-creation-receivable",
    //   allowedRoles: [6,8,10],
    // },
    // {
    //   label: "Register",
    //   icon: AppRegistrationIcon,
    //   path: "",
    //   allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    //   subMenu: [
    //     {
    //       label: "Inventory Stock And Material Register",
    //       icon: PaymentRoundedIcon,
    //       path: "/inventory-stock-material-register",
    //       allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    //     },
    //     {
    //       label: "Consolidated Abstract Register",
    //       icon: AppRegistrationIcon,
    //       path: "/consolidated-abstract-register",
    //       allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    //     },
    //     {
    //       label: "Inventory Management",
    //       icon: PaymentRoundedIcon,
    //       path: "/inventory-management",
    //       allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    //     },
    //   ],
    // },
    {
      label: "Book",
      icon: ReceiptIcon,
      path: "",
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
      subMenu: [
        {
          label: "Ledger Book",
          icon: ReceiptIcon,
          path: "/ledger-book",
          allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
        },

        {
          label: "Vendor Ledger",
          icon: ReceiptIcon,
          path: "/vendor-ledger",
          allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
        },

        // {
        //   label: "Monthly & Yearly Cashbook",
        //   icon: ReceiptIcon,
        //   path: "/monthly-yearly-cashbook",
        //   allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
        // },
      ],
    },
    // {
    //   label: "Statement",
    //   icon: PaymentRoundedIcon,
    //   path: "",
    //   allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    //   subMenu: [
    //     {
    //       label: "Bank Statement",
    //       icon: PaymentRoundedIcon,
    //       path: "/bank-statement",
    //       allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    //     },
    //     {
    //       label: "Cash withdraw",
    //       icon: PaymentRoundedIcon,
    //       path: "/cash-withdraw",
    //       allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    //     },
    //     {
    //       label: "Monthly Reconciliation Statement",
    //       icon: Event,
    //       path: "/monthly-reconciliation-statement",
    //       allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    //     },
    //     {
    //       label: "Receivable & Payable Statement",
    //       icon: CreditScoreIcon,
    //       path: "/receivable-and-payable-statement",
    //       allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    //     },
    //   ],
    // },

    
    {
      label: "Vendor Payment Release",
      icon: PaymentRoundedIcon,
      path: "/vendor-payment-release",
      allowedRoles: [7,9,11],
    },

    // {
    //   label: "Demand Collection Sheet",
    //   icon: PaymentRoundedIcon,
    //   path: "/demand-collection-balance-sheet",
    //   allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    // },

    // {
    //   label:"Inventory Stock And Material Register",
    //   icon: PaymentRoundedIcon,
    //   path:"/inventory-stock-material-register"
    // },
    
    // {
    //   label: "Work Wise Material Register",
    //   icon: PaymentRoundedIcon,
    //   path: "/work-wise-material-register",
    //   allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    // },
    {
      label: "Vendor Registration",
      icon: PaymentRoundedIcon,
      path: "/vendor-registration",
      allowedRoles: [6, 8,10],
    },
    {
      label: "Vendor Approval",
      icon: PaymentRoundedIcon,
      path: "/vendor-approval",
      allowedRoles: [7,9,11],
    },
    {
      label: "Payment Heads",
      icon: PaymentRoundedIcon,
      path: "/payment-expenditure",
      allowedRoles: [1,2,3,4,5,6,8,10,38],
    },
    // {
    //   label: "Edit Tax",
    //   icon: PaymentRoundedIcon,
    //   path: "/All-tax",
    //   allowedRoles: [1,2,3,4,5],
    // },
    {
      label: "Update Vendor",
      icon: PaymentRoundedIcon,
      path: "/update-vendor",
      allowedRoles: [1,2,3,4,5,6,8,10],
    },
    {
      label: "Deducted Tax",
      icon: PaymentRoundedIcon,
      path: "/deducted-tax",
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    },
    {
      label: "Payment Tracking",
      icon: PaymentRoundedIcon,
      path: "/payment-track",
      allowedRoles: [1,2,3,4,5,6,7,8,9,10,11,38],
    },
  ];

  const renderSidebarMenuItems = () => {
    return sidebarMenuItems
      .filter((item) => item.allowedRoles.includes(role))
      .map((item) => {
        if (item.subMenu) {
          return (
            <SubMenu
              label={item.label}
              icon={<item.icon />}
              className="SubMenu"
            >
              {item.subMenu.map((subItem) => (
                <Link
                  to={subItem.path}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MenuItem
                    // icon={<subItem.icon />}
                    className={
                      activeMenu === subItem.path
                        ? "menuItem active"
                        : "SubMenu"
                    }
                  >
                    {subItem.label}
                  </MenuItem>
                </Link>
              ))}
            </SubMenu>
          );
        } else {
          // Wrap the MenuItem content in a Link for the main menu
          return (
            <Link
              to={item.path}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <MenuItem
                icon={<item.icon />}
                className={
                  activeMenu === item.path ? "menuItem active" : "menuItem"
                }
              >
                {item.label}
                {item.additionalIcon && (
                  <item.additionalIcon sx={{ color: "#d60606" }} />
                )}
              </MenuItem>
            </Link>
          );
        }
      });
  };
  return (
    
    <div className="maindiv d-flex" style={{ overflow: "hidden", height: "100vh" }}>
      
      <Sidebar className="sidebar hide-on-print" collapsed={!sidebar}>
      
        <Menu>
          <div className="logo mt-3 ">
            <span>
            <img src={title} alt="title" style={{ height: "4rem", marginBottom: "0" }} />
            </span>
            <span
              className="mt-1" 
              style={{ color: "black", display: !sidebar ? "none" : "block", margin: "0",    marginLeft: "-9px" 
              }} 
            >
    <h5 style={{ margin: "0" }}>Dept. Of Haryana</h5>
    </span>
          </div>
          <div className="d-flex justify-content-center row my-4">
            <img
              src={logo}
              alt="userImg"
              style={{ height: "3.8rem", width: "5.2rem" }}
            />
            {/* <AccountCircleIcon style={{ height: "6rem", width: "6rem" }} /> */}
            {sidebar ? (
              <>
                <span
                  className="d-flex"
                  style={{
                    color: "black",
                    alignItems: "center",
                    justifyContent: "Center",
                  }}
                >
                  <h5
                    style={{
                      fontFamily: "Times New Roman",
                      fontWeight: "bold",
                    }}
                  >
                    {userData && userData.data.user_firstname}
                  </h5>
                </span>
                <span
                  className="d-flex mb-3"
                  style={{
                    color: "black",
                    alignItems: "center",
                    justifyContent: "Center",
                  }}
                >
                  <p style={{ fontFamily: "Times New Roman" }}>
                    {userData && userData.data.role_name}
                  </p>
                </span>
              </>
            ) : (
              <div></div>
            )}
          </div>
          {renderSidebarMenuItems(role)}
        </Menu>
      </Sidebar>
    </div>
  );
};

export default Sidebars;
